<template>
  <div class="page-content mb-8 mt-4">
    <div class="container">
      <div class="store store-wcfm-banner">
        <figure class="store-media">
          <img
            :src="gongsi.banner || $tupianmoren"
            style="background-color: #40475e; width: 1240px; height: 460px"
          />
        </figure>
        <div class="store-content">
          <div class="store-content-left mr-auto">
            <div class="personal-info">
              <figure class="seller-brand" style="background-color: #ffffffdd">
                <img
                  :src="gongsi.logo || $tupianmoren"
                  style="height: 100px; width: 100px"
                />
              </figure>
            </div>
            <div class="address-info">
              <h4 class="store-title">
                {{ duoyuyan(gongsi) }}
              </h4>
              <ul class="seller-info-list list-style-none">
                <li class="store-address">
                  <i class="w-icon-map-marker"></i>
                  {{ gongsi.dizhi }} {{ gongsi.codepostal }}
                  {{ gongsi.chengshi }}
                </li>
                <li class="store-phone">
                  <a :href="'tel:' + gongsi.dianhua">
                    <i class="w-icon-phone"></i>
                    {{ gongsi.dianhua }}
                  </a>
                </li>
                <li class="store-email">
                  <a :href="'email:' + gongsi.email">
                    <i class="far fa-envelope"></i>
                    {{ gongsi.email }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="store-content-right">
            <!-- <div
              v-if="gongsi.fuwu && gongsi.fuwu.length === 1"
              class="btn btn-white btn-rounded btn-icon-left btn-inquiry"
              @click="
                $router.push({
                  path: '/service',
                  query: { ukey: gongsi.fuwu[0].ukey, gongsi: gongsi.ukey },
                })
              "
            >
              <i class="far fa-question-circle"></i>
              {{ $shezhi.gongsifuwu }}
            </div> -->
            <div class="social-icons social-icons-colored border-thin">
              <a
                v-if="gongsi.facebook"
                :href="gongsi.facebook"
                class="social-icon social-facebook w-icon-facebook"
              ></a>
              <a
                v-if="gongsi.twitte"
                :href="gongsi.twitter"
                class="social-icon social-twitter w-icon-twitter"
              ></a>
              <a
                v-if="gongsi.linkedin"
                :href="gongsi.linkedin"
                class="social-icon social-linkedin fab fa-linkedin"
              ></a>
              <a
                v-if="gongsi.youtube"
                :href="gongsi.youtube"
                class="social-icon social-youtube w-icon-youtube"
              ></a>
              <a
                v-if="gongsi.instagram"
                :href="gongsi.instagram"
                class="social-icon social-instagram w-icon-instagram"
              ></a>
            </div>
          </div>
        </div>
      </div>
      <div class="container icon-box">
        <div
          class="icon-box-item"
          v-for="(item, index) in gongsi.fuwu"
          :key="index"
          @click="
            $router.push({
              path: '/service',
              query: { ukey: item.ukey, gongsi: gongsi.ukey },
            })
          "
        >
          <img
            :src="item.tupian"
            style="width: 50px; height: 50px; margin-right: 12px"
          />
          <div class="icon-box-content" style="width: 200px">
            <h4 class="icon-box-title hang" style="text-align: left">
              {{ duoyuyan(item) }}
            </h4>
            <p
              class="text-default hang"
              style="text-align: left"
              v-html="duoyuyan(item, 'miaoshu')"
            ></p>
          </div>
        </div>
      </div>
      <div class="row gutter-lg">
        <aside
          class="sidebar left-sidebar vendor-sidebar sticky-sidebar-wrapper sidebar-fixed"
        >
          <div class="sidebar-overlay"></div>
          <a class="sidebar-close" href="#"><i class="close-icon"></i></a>
          <a href="#" class="sidebar-toggle">
            <i class="w-icon-angle-right"></i>
          </a>
          <div class="sidebar-content">
            <div class="sticky-sidebar">
              <!-- <div class="widget widget-collapsible widget-coupons">
                <h3 class="widget-title"><span>Store Coupons</span></h3>
                <div class="widget-body">
                  <div class="coupon">
                    First Shopping Coupon
                    <div class="coupon-tip">
                      <div class="coupon-info-title">FREE Shipping Coupon</div>
                      <div class="coupon-info-date">April 30, 2021</div>
                      <div>Test coupon for vendor page</div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="widget widget-collapsible widget-time">
                <h3 class="widget-title">
                  <span>
                    <i class="far fa-clock"></i>
                    {{ $yuyanbao.yingyeshijian }}
                  </span>
                </h3>
                <ul class="widget-body">
                  <li>
                    <span>{{ $yuyanbao.xingqiyi }}:</span>
                    {{ gongsi.xingqiyi }}
                  </li>
                  <li>
                    <span>{{ $yuyanbao.xingqier }}:</span>
                    {{ gongsi.xingqier }}
                  </li>
                  <li>
                    <span>{{ $yuyanbao.xingqisan }}:</span>
                    {{ gongsi.xingqisan }}
                  </li>
                  <li>
                    <span>{{ $yuyanbao.xingqisi }}:</span>
                    {{ gongsi.xingqisi }}
                  </li>
                  <li>
                    <span>{{ $yuyanbao.xingqiwu }}:</span>
                    {{ gongsi.xingqiwu }}
                  </li>
                  <li>
                    <span>{{ $yuyanbao.xingqiliu }}:</span>
                    {{ gongsi.xingqiliu }}
                  </li>
                  <li>
                    <span>{{ $yuyanbao.xingqiri }}:</span>
                    {{ gongsi.xingqiri }}
                  </li>
                </ul>
              </div>
              <!-- <div class="widget widget-collapsible">
                <h3 class="widget-title">
                  <span>
                    <i class="w-icon-truck"></i>
                    Shipping Rules
                  </span>
                </h3>
                <div class="widget-body">
                  <p class="mb-0">Delivery Time: 1-2 business days</p>
                </div>
              </div> -->
              <div class="widget widget-collapsible widget-location">
                <h3 class="widget-title">
                  <span>
                    <i class="w-icon-map-marker"></i>
                    {{ gongsi.dizhi }} {{ gongsi.codepostal }}
                    {{ gongsi.chengshi }}
                  </span>
                </h3>
                <div class="widget-body">
                  <iframe
                    :src="gongsi.location"
                    width="280"
                    height="280"
                    style="border: 0"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </aside>

        <div class="main-content">
          <div class="tab tab-nav-underline tab-nav-boxed tab-vendor-wcfm">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a href="#tab-1" class="nav-link active">{{
                  $yuyanbao.shangpin
                }}</a>
              </li>
              <li class="nav-item">
                <a href="#tab-2" class="nav-link">{{
                  $yuyanbao.guanyuwomen
                }}</a>
              </li>
              <li class="nav-item">
                <a href="#tab-3" class="nav-link">{{
                  $yuyanbao.falushengming
                }}</a>
              </li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="tab-1">
                <div class="product-wrapper row cols-md-3 cols-sm-2 cols-2">
                  <div
                    class="product-wrap"
                    v-for="(item, index) in gongsi.shangpin"
                    :key="index"
                  >
                    <div class="product product-simple text-center">
                      <figure class="product-media">
                        <a
                          href="javascript: void(0);"
                          v-if="item.tupian && item.tupian.length > 0"
                        >
                          <img
                            :src="item.tupian[0]"
                            alt=""
                            width="300"
                            height="338"
                          />
                        </a>
                        <div class="product-action">
                          <router-link
                            :to="{
                              path: '/product',
                              query: { ukey: item.ukey },
                            }"
                            class="btn-product btn-quickview"
                          >
                            {{ $yuyanbao.xiangqing }}
                          </router-link>
                        </div>
                      </figure>
                      <div class="product-details">
                        <h4 class="product-name">
                          <a> {{ duoyuyan(item) }}</a>
                        </h4>
                        <div class="product-pa-wrapper">
                          <div class="product-price">
                            {{ (item.jiage / 100).toFixed(2) + "€" }}
                          </div>
                          <!-- <div class="product-action">
                            <a class="btn-cart btn-product btn btn-icon-right btn-link btn-underline">
                              Add To Cart
                            </a>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="tab-2">
                <p class="mb-4" v-html="$shezhi.guanyuwomen"></p>
                <p v-html="$shezhi.guanyuwomen2"></p>
              </div>
              <div class="tab-pane" id="tab-3">
                <div class="policies-area">
                  <p v-html="gongsi.mentionlegal"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGongSi } from "@/api/gongsi";

export default {
  name: "Boutique1",
  components: {},
  data() {
    return {
      ukey: "",
      gongsi: {},
      loading: false,
    };
  },
  mounted() {
    this.ukey = this.$route.query.ukey;
    this.get_gongsi_http();
  },
  methods: {
    get_gongsi_http() {
      this.loading = true;
      getGongSi({ ukey: this.ukey })
        .then((data) => {
          if (data.status === "SUCCESSED") this.gongsi = data.data;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.ratings-full::before {
  color: rgba(255, 255, 255, 0.8);
}

.icon-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow: scroll;
  border: 1px solid #eee;
  border-radius: 0.5rem;
  margin: 40px 0;
}
.icon-box-item {
  display: flex;
  align-items: center;
  margin: 40px 20px;
  flex-shrink: 0;
  cursor: pointer;
}
</style>
